// Fire Register API functions
import { getSessionUUID } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";


export const fetch_todays_register = async () => {
    try {
        const sessionToken = await getSessionUUID(); // Use the utility function

        const response = await fetch('/register/get_todays_register', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        });

        const responseBody = await response.json();

        if (response.status === 200) {
            return {
                message: 'Register data fetched successfully',
                status: response.status,
                data: responseBody
            };
        } else {
            return {
                message: responseBody.error || 'Failed to fetch register data',
                status: response.status,
                data: null
            };
        }
    } catch (err) {
        logger.error("Error fetching register data:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
            data: null
        };
    }
};

export const add_register_entry = async (entryData) => {
    try {
        const sessionToken = await getSessionUUID(); // Use the utility function

        const response = await fetch('/register/add_register_entry', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(entryData),
        });

        const responseBody = await response.json();

        if (response.status === 200) {
            return {
                message: responseBody.message || 'Register entry added successfully',
                status: response.status,
                data: responseBody.data
            };
        } else {
            return {
                message: responseBody.error || 'Failed to add register entry',
                status: response.status,
                data: null
            };
        }
    } catch (err) {
        logger.error("Error adding register entry:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
            data: null
        };
    }
};

export const update_register_entry = async (entryId, updateData) => {
    try {
        const sessionToken = await getSessionUUID(); // Use the utility function

        const requestData = {
            id: entryId,
            ...updateData
        };

        const response = await fetch('/register/update_register_entry', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(requestData),
        });

        const responseBody = await response.json();

        if (response.status === 200) {
            return {
                message: responseBody.message || 'Register entry updated successfully',
                status: response.status,
                data: responseBody.data
            };
        } else {
            return {
                message: responseBody.error || 'Failed to update register entry',
                status: response.status,
                data: null
            };
        }
    } catch (err) {
        logger.error("Error updating register entry:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
            data: null
        };
    }
};
